import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { KakaoService } from 'src/app/services/kakao/kakao.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { SignupService } from 'src/app/services/signup/signup.service'
import { UserService } from 'src/app/services/user/user.service'

@Component({
  selector: 'app-quiz-profile',
  templateUrl: './quiz-profile.component.html',
  styleUrls: ['./quiz-profile.component.scss'],
})
export class QuizProfileComponent implements OnInit {
  @Input() firstName: string | undefined
  @Input() lastName: string | undefined
  @Input() hideProfile = false
  @Input() type: 'host' | 'guest' = 'host'
  @Input() loginDescription = this.localeService.getLocaleString('월드컵 결과로\n나와 친구의 취향 궁합을 분석해드려요')
  @Input() from: string = 'quiz_profile'
  @Input() disableHideProfile = false
  @Input() isHostLoginNeeded = true
  @Output() firstNameChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() lastNameChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() hideProfileChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor(
    public userService: UserService,
    private kakaoService: KakaoService,
    private logService: LogService,
    private localeService: LocaleService,
    private signupService: SignupService
  ) {}

  get isLocaleKo(): boolean {
    return this.localeService.isKo
  }

  get isLoggedIn(): boolean {
    return this.userService.isLoggedIn
  }

  get title(): string {
    if (!this.hideProfile) {
      return '나의 프로필'
    }
    return '내 이름 입력'
  }

  ngOnInit(): void {
    // 이름 없으면 프로필 숨김으로만 진행
    if (!this.userService.user.profile?.firstName) {
      this.hideProfile = true
      this.disableHideProfile = true
      const emitTimeout = setTimeout(() => {
        this.hideProfileChange.emit(true)
        clearTimeout(emitTimeout)
      }, 10)
    }
  }

  onHideButtonClicked(): void {
    this.hideProfile = !this.hideProfile
    this.hideProfileChange.emit(this.hideProfile)
  }

  onChangeValue(type: 'firstName' | 'lastName'): void {
    // login O host 이름 입력시
    if (type === 'firstName') {
      this.firstNameChange.emit(this.firstName)
    } else {
      this.lastNameChange.emit(this.lastName)
    }
  }

  handleFirstNameChange(newFirstName: string) {
    this.firstName = newFirstName
    this.firstNameChange.emit(newFirstName)
  }

  handleLastNameChange(newLastName: string) {
    this.lastName = newLastName
    this.lastNameChange.emit(newLastName)
  }

  onClickLogin(): void {
    this.logService.eventLogging(LogEvent.KAKAO_LOGIN_CLICKED, { from: this.from })
    this.kakaoService.login(location.pathname + location.search)
  }
}
